import React, { useEffect, useState } from 'react';
import { DateRangePicker } from 'rsuite';
import { useObjCommonFilterStore } from 'src/hooks/objCommonFilter';
import { useOrderStore } from 'src/hooks/order';
import moment from 'moment'
import Helper from 'src/helper/Helper';
import System from 'src/helper/system';
import Constants from 'src/helper/Constants';
import useReduxState from 'src/hooks/useReduxState';

const OrderAdvanceFilterPopup = (props) => {
    const { SetStatus } = props
    const { translation: t } = System;

    const [{ order_manufacturer_list }, { fetch_manuFacturer_list }, { }] = useOrderStore();
    const defaulDateRange = [null, null];
    const [expectedDateRangeObject, setExpectedDateRangeObject] = useState(defaulDateRange);
    const [customerRequestedDateObject, setCustomerRequestedDateObject] = useState(defaulDateRange);
    const [{ filter_list }, { }, { set_filter_list }] = useObjCommonFilterStore();
    const filterDetail = { mfrPartNumber: '', custMatNum: "", manufacturer: "" };
    const [formData, setFormData] = useState(filterDetail)
    const [dateRange] = useReduxState('', 'setDateRange');

    const { storageName: { ORDER_PAGE_TOKEN }, avUserInfoData: { currentUser } } = System
    const isCoreUser = currentUser === Constants.siteUser.CORE

    const statusList = {
        R: { id: "R", text: t('orderReceived'), searchKey: 'Order Received', slug: 'OrderReceived' },
        P: { id: "P", text: t('orderInProcess'), searchKey: 'Order in Process', slug: 'OrderinProcess' },
        PS: { id: "PS", text: t('partiallyShipped'), searchKey: 'Partially Shipped', slug: 'PartiallyShipped' },
        PC: { id: "PC", text: t('partiallyCancelled'), searchKey: 'Partially Cancelled', slug: 'PartiallyCancelled' },
        S: { id: "S", text: t('shipped'), searchKey: 'Shipped', slug: 'Shipped' },
        C: { id: "C", text: t('cancelled'), searchKey: 'Cancelled', slug: 'Cancelled' }
    };

    const searchList = [
        { key: "orderStatus", searchType: t('orderStatus'), searchKeywordArr: [] },
        { key: "mfrPartNumber", searchType: t('manufacturerPartNo'), searchKeyword: "" },
        { key: "custMatNum", searchType: t('customerPartNumber'), searchKeyword: "" },
        { key: "manufacturer", searchType: t('manufacturer'), searchKeywordArr: "", manufacturerName: "" },
        { key: "deliveryDate", searchType: t('expectedDeliveryDate'), searchKeyword: "" },
        { key: "scheduleDate", searchType: t('customerRequestedDateRange'), searchKeyword: "" },
    ]

    useEffect(() => {
        async function fetchHere() {
            const params = {
                "startDate": dateRange.split(';')[0],
                "endDate": dateRange.split(';')[1],
                "poNumber": filter_list?.poNumber?.searchKeyword?.trim(),
                "orderCreationType": filter_list?.orderType?.searchKeyword,
                "webOrderNum": filter_list?.orderNumber?.searchKeyword?.trim(),
                "invoiceNum": filter_list?.invoiceNo?.searchKeyword?.trim(),
                "shippingTrackingNum": filter_list?.trackingNo?.searchKeyword?.trim(),
                "doNum": filter_list?.doNumber?.searchKeyword?.trim(),
            }
            await fetch_manuFacturer_list(params);
        }
        fetchHere();
    }, []);

    useEffect(() => {
        if (Object.keys(filter_list)?.length > 0) {
            let filterData = filterDetail;
            Object.keys(filter_list).forEach((property) => {
                if (filter_list[property]) {
                    if (filter_list[property].key === 'orderStatus') {
                        filter_list[property].searchKeywordArr?.forEach(ele => {
                            let statusId = Object.values(statusList)?.find(f => f.text.toLocaleLowerCase() === ele.label.toLocaleLowerCase())?.id;
                            filterData[statusId] = statusId;
                        });
                    } else if (filter_list[property].key === 'deliveryDate') {
                        setExpectedDateRangeObject(setInitialDateVal(filter_list[property].searchKeyword))
                    } else if (filter_list[property].key === 'scheduleDate') {
                        setCustomerRequestedDateObject(setInitialDateVal(filter_list[property].searchKeyword))
                    }
                    else if (filter_list[property].key === 'manufacturer') {
                        filterData[filter_list[property].key] = filter_list[property].searchKeyword + "///" + filter_list[property].manufacturerName;
                    }
                    else {
                        filterData[filter_list[property].key] = filter_list[property].searchKeyword;
                    }
                }
            });
        }
    }, []);

    const parseOrderDate = (dateStr) => {
        const [day, month, year] = dateStr?.trim().split('/').map(part => parseInt(part, 10));
        return new Date(year, month - 1, day);
    };

    const setInitialDateVal = (dtObj) => {
        let _dt = dtObj.split("-");
        _dt[0] = parseOrderDate(_dt[0]);
        _dt[1] = parseOrderDate(_dt[1]);
        return _dt;
    }

    const onHide = (action = true) => {
        SetStatus(false)
    };

    const onValueChange = (field, value) => {
        if (field === 'manufacturer') {
            setFormData({ ...formData, [field]: value })
        } else {
            setFormData({ ...formData, [field]: value })
        }
    }

    const onSelectStatus = (e) => {
        const val = e.target.value;
        if (e.target.checked) {
            setFormData({ ...formData, [val]: val })
        } else {
            let data = { ...formData };
            delete data[val];
            setFormData(data);
        }
    }

    const onApplyFilter = async () => {
        let data = formData;
        let orderSearch = {};
        let statusListSel = {};

        localStorage.removeItem(ORDER_PAGE_TOKEN)

        if (JSON.stringify(expectedDateRangeObject) !== JSON.stringify(defaulDateRange))
            data.deliveryDate = setDateForFilter(expectedDateRangeObject);
        if (JSON.stringify(customerRequestedDateObject) !== JSON.stringify(defaulDateRange))
            data.scheduleDate = setDateForFilter(customerRequestedDateObject);

        Object.keys(data).forEach((property) => {
            if (data[property].trim()) {
                let searchObj = searchList.find(f => f.key === property)
                if (searchObj?.key === 'manufacturer') {
                    searchObj.searchKeyword = data[property].trim()?.split('///')[0];
                    searchObj.manufacturerName = data[property].trim()?.split('///')[1];
                    orderSearch[searchObj.key] = searchObj;
                } else if (searchObj) {
                    searchObj.searchKeyword = data[property].trim();
                    orderSearch[searchObj.key] = searchObj;
                } else {
                    if (statusList[data[property]]?.text) {
                        statusListSel[property] = { value: statusList[data[property]]?.searchKey, label: statusList[data[property]]?.text };
                    }
                }
            }
        });

        if (Object.keys(statusListSel).length > 0) {
            let searchObj = searchList.find(f => f.key === "orderStatus")
            searchObj.searchKeywordArr = Object.values(statusListSel);
            orderSearch[searchObj.key] = searchObj;
        }

        const updatedFilterList = await updateAndFilterFilterList(formData, filter_list, statusListSel);

        let _deliveryDate = formData?.deliveryDate?.split("-");
        let _scheduleDate = formData?.scheduleDate?.split("-");

        if (_deliveryDate) {
            formData.atsStartDate = Helper.convertToYYYYMMDD(_deliveryDate[0])
            formData.atsEndDate = Helper.convertToYYYYMMDD(_deliveryDate[1])
            delete formData["deliveryDate"]
        }

        if (_scheduleDate) {
            formData.crdStartDate = Helper.convertToYYYYMMDD(_scheduleDate[0])
            formData.crdEndDate = Helper.convertToYYYYMMDD(_scheduleDate[1])
            delete formData["scheduleDate"]
        }

        const differences = JSON.stringify({ ...updatedFilterList, ...orderSearch }) !== JSON.stringify(filter_list);

        if (differences) {
            set_filter_list({ ...updatedFilterList, ...orderSearch });
            onHide();
        } else {
            onHide();
        }
    }

    const updateAndFilterFilterList = (formData, currentFilterList, statusListSel) => {
        let updatedFilterList = { ...currentFilterList };

        if (Object.keys(statusListSel).length <= 0 && updatedFilterList['orderStatus']) {
            delete updatedFilterList['orderStatus']
        }

        Object.keys(formData).forEach(key => {
            if (formData[key] === "" && updatedFilterList[key]) {
                delete updatedFilterList[key];
            } else if (formData[key] !== "" && updatedFilterList[key]) {
                if (updatedFilterList[key] && typeof updatedFilterList[key] === 'object' && !Array.isArray(updatedFilterList[key])) {
                    if (updatedFilterList[key].searchKeyword !== formData[key]) {
                        updatedFilterList = {
                            ...updatedFilterList,
                            [key]: {
                                ...updatedFilterList[key],
                                searchKeyword: formData[key]
                            }
                        };
                    }
                }
            }
        });

        return updatedFilterList;
    };

    useEffect(() => {
        if (expectedDateRangeObject[0] !== null)
            setDateForFilter(expectedDateRangeObject);
    }, [expectedDateRangeObject])

    useEffect(() => {
        if (customerRequestedDateObject[0] !== null)
            setDateForFilter(customerRequestedDateObject);
    }, [customerRequestedDateObject])

    const setDateForFilter = (dtObj) => {
        let dt1_frm = moment(dtObj[0]).local().format(Helper.getddMMyyyyFormat().toUpperCase());
        let dt2_frm = moment(dtObj[1]).local().format(Helper.getddMMyyyyFormat().toUpperCase());
        let _dt = dt1_frm + ' - ' + dt2_frm;
        return _dt;
    }

    const onExpectedDateRange = (e) => {
        if (e) {
            setExpectedDateRangeObject(e)
        } else {
            setExpectedDateRangeObject(defaulDateRange)
        }
    }
    const onCustomerRequestedRange = (e) => {
        if (e) {
            setCustomerRequestedDateObject(e)
        } else {
            setCustomerRequestedDateObject(defaulDateRange)
        }
    }

    return (
        <>
            <div className=" avnet-modal modal-730">
                <div className="avnet-modal-inner">
                    <button type="button" className="close py-3" data-dismiss="modal"
                        onClick={() => { onHide() }}>×</button>
                    <div className="modal-header">
                        <h4 className="modal-title text-center">{t('filterOrders')}</h4>
                    </div>
                    <form id="hook-form">
                        <div className="modal-body pb-2">
                            <div className="filter-by-status mb-3 border-top-0 pt-0 pb-2">
                                <div className="popup-subheader font-apecru font-16 mb-3">{t('filterByOrderStatus')}</div>
                                <div className="filter-by-status-checkboxes">
                                    {statusList && Object.keys(statusList).map((v) => (
                                        <section className="form-check form-check-inline sm-custom_checkbox" key={v} >
                                            <input type="checkbox" className="form-check-input" id={statusList[v].id} name={v} value={v} onChange={onSelectStatus} checked={formData[v] ? true : false} />
                                            <label className="form-check-label mt-0" id={statusList[v].id}>{statusList[v].text}</label>
                                        </section>
                                    ))}
                                </div>
                            </div>
                            <div className='filter-by-status mb-3 border-top-0 pt-0 pb-2'>
                                <div className="row bs5">
                                    <div className="form-group col-4 mb-2 pb-1">
                                        <label htmlFor="usr">{t('expectedDeliveryDate')}</label>
                                        <DateRangePicker
                                            style={{ width: '100% !important' }}
                                            placeholder={t('dateRange')}
                                            onChange={(dates, event) => {
                                                onExpectedDateRange(dates);
                                            }}
                                            value={expectedDateRangeObject}
                                            ranges={[]}
                                            character=" - "
                                            cleanable={false}
                                            format={Helper.getddMMyyyyFormat()}
                                            editable={false}
                                            className="w-100 datepickerinputdisable"
                                        />
                                    </div>
                                    {isCoreUser && <div className="form-group col-4 mb-2 pb-1">
                                        <label htmlFor="usr">{t('customerRequestedDateRange')}</label>
                                        <DateRangePicker
                                            style={{ width: '100% !important' }}
                                            placeholder={t('dateRange')}
                                            onChange={(dates, event) => {
                                                onCustomerRequestedRange(dates);
                                            }}
                                            value={customerRequestedDateObject}
                                            ranges={[]}
                                            character=" - "
                                            cleanable={false}
                                            format={Helper.getddMMyyyyFormat()}
                                            editable={false}
                                            className="w-100 datepickerinputdisable"
                                        />
                                    </div>}
                                </div>
                            </div>


                            <div className="row bs5">
                                {isCoreUser && <div className="form-group col-4 mb-1">
                                    <label htmlFor="usr">{t('customerPartNumber')}</label>
                                    <input type="text" className="form-control form-control-sm" id="customerPartNumber" placeholder={t('customerPartNumber')} value={formData.custMatNum} onChange={({ target: { value } }) => onValueChange('custMatNum', value)} />
                                </div>}
                                <div className="form-group col-4 mb-1">
                                    <label htmlFor="usr">{t('manufacturerPartNumber')}</label>
                                    <input type="text" className="form-control form-control-sm" id="mfrPartNumber" placeholder={t('manufacturerPartNumber')}
                                        value={formData.mfrPartNumber} onChange={({ target: { value } }) => onValueChange('mfrPartNumber', value)} />
                                </div>
                                <div className="form-group col-4 mb-1">
                                    <label htmlFor="usr">{t('manufacturer')}</label>
                                    <div className="selectbox">
                                        <select className="form-control form-control-sm" id="manufacturerName" value={formData.manufacturer} onChange={({ target: { value } }) => onValueChange('manufacturer', value)} >
                                            <option value="">{t('selectManufacturer')}</option>
                                            {order_manufacturer_list?.length && order_manufacturer_list?.map((v, i) => (
                                                <option key={v.manufacturer} value={v.manufacturer + "///" + v.parentManufacturerName}>{v.parentManufacturerName}</option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer text-center">
                            <button type="button" className="bs5 btn btn-secondary w145" data-dismiss="modal"
                                onClick={() => { onHide() }}>{t('close')}</button>
                            <button type="button" className="bs5 btn btn-primary w145" onClick={onApplyFilter}>{t('applyFilters')}</button>
                        </div>
                    </form>
                </div>
            </div>
        </>
    )
}

export default OrderAdvanceFilterPopup;